import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Box, useTheme } from "@mui/material";
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Text from "../../../../theme/text/Text";
import { setPrimaryFilter } from "../../../../../newapi/global/filter/reportFilterSlice";
import { tokens } from "../../../../../theme";
import { reportFilterDataSource } from '../../chartFilterEnums';
import { useEffect, useState } from 'react';
import { useReportHubFilters } from '../../ReportHubFilterContext';
import { DropdownBaseV2, ShDropdownSearchQuery } from '../../../../theme/dropdowns/Dropdown';

export const CategorySearchQueryDropdown = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const filtersRegistry = useReportHubFilters();


    // resolve filter function
    const filter = filtersRegistry.filters[props.fKey];
    const resolvedFilter = typeof filter === "function" ? filter() : filter;

    return (
        <ShDropdownSearchQuery
            content={resolvedFilter.hook}
            // selected={props.category.values?.map(item => item.id)}
            displayName={resolvedFilter.dropdownOptions?.displayName ?? "name"}
            valueKey={resolvedFilter.dropdownOptions?.valueKey ?? "id"}
            searchOptions={{
                enabled: true,
                placeholder: t("search")
            }}
            stopPropagation
            noPropagationOnSelect
            multiple
            onChange={(selected,newOne) => {
                // // compute selected items first
                const displayKey = resolvedFilter.dropdownOptions?.displayName ?? "name";
                const valueKey = resolvedFilter.dropdownOptions?.valueKey ?? "id";

                props.setCurrentReport((prev) => {
                    const currentValue = prev?.category?.values || [];

                    // Check if newOne[valueKey] exists in current value
                    const existingIndex = currentValue.findIndex(item => item[valueKey] === newOne[valueKey]);

                    let updatedValue;
                    if (existingIndex !== -1) {
                        // Item exists, remove it
                        updatedValue = currentValue.filter((_, idx) => idx !== existingIndex);
                    } else {
                        // Item doesn't exist, add it with only displayKey and valueKey
                        updatedValue = [
                            ...currentValue,
                            {
                                [displayKey]: newOne[displayKey],
                                [valueKey]: newOne[valueKey],
                            }
                        ];
                    }

                    return {
                        ...prev,
                        category:{
                            ...prev?.category,
                            values: updatedValue,
                        },
                    };
                });
            }}

        >
            {({anchorEl,onClick}) => (
                <Box
                    className={cx(undefined, {
                        'from-view':props.fromView,
                    })}
                    // key={"rp"+idx}
                    onClick={onClick}
                    sx={{
                        px:2,
                        height:32,
                        borderRadius:4,
                        display:"flex",
                        alignItems:'center',
                        cursor:"pointer",
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                        "&:hover .rp-value-container" : {
                            pr:4,
                        },
                        "&:hover .rp-value-container .rp-filter-icon" : {
                            zIndex:1,
                            opacity:1,
                                transition:"125ms",
                        },

                        '&.from-view' : {
                            height:24,
                        }
                    }}
                >
                    {props.category?.values?.length > 0 ?
                        <>
                            <Text noBreak bold>{props.category?.values?.length}</Text>
                            <Text noBreak light sx={{ml:0.5,}}>
                                {t("selected")}
                            </Text>
                        </>
                    :
                        <Text noBreak>{t("no_selection")}</Text>
                    }
                </Box>
            )}
        </ShDropdownSearchQuery>
    )
}